import { route } from "@helpers"
import useArchive from "@hooks/useArchive"

export default function useGalleryArchive(photos?: Interfaces.Photo.Includes<"acceptances_count" | "awards_count" | "salons_count">[]) {
    const archive = useArchive(photos)

    archive.useOptions({ box: true })

    archive.useEmpty({
        heading: "Photos you upload to salons will be displayed here",
        description: "You should upload photos to a contest to see them in the list. Choose a salon on \"Open Salons\" page.",
        button: {
            value: "See Salons",
            to: route("customer:current")
        }
    })

    archive.useGrid({
        columns: "4",
        gap: "m"
    })

    return archive
}